module.exports = __webpack_public_path__ + "files/8761f6674f4e8c0934a19c8c2a3442ec.png";